// in src/comments.js
import * as React from 'react';
import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import {
    DateField,
    EditButton,
    NumberField,
    TextField,
    RecordContextProvider,
    useListContext,
} from 'react-admin';

import { Admin } from '../types';

const MobileGrid = () => {
    const { data, isLoading } = useListContext<Admin>();

    if (isLoading || data.length === 0) {
        return null;
    }

    return (
        <Box margin="0.5em">
            {data.map(record => (
                <RecordContextProvider key={record.id} value={record}>
                    <Card sx={{ margin: '0.5rem 0' }}>
                        <CardHeader
                            title={`${record.first_name} ${record.last_name}`}
                            subheader={
                                <>
                                    <DateField source="date_joined" />
                                </>
                            }
                            action={<EditButton />}
                        />
                        <CardContent sx={{ pt: 0 }}>
                            <Typography variant="body2">
                                <NumberField source="id" />
                                <TextField source="username" />
                            </Typography>
                            <Typography variant="body2">
                                <TextField source="first_name" />
                                <TextField source="last_name" />
                            </Typography>
                        </CardContent>
                    </Card>
                </RecordContextProvider>
            ))}
        </Box>
    );
};

export default MobileGrid;
